import { Component, Input } from '@angular/core';
import { DnButtonBaseComponent } from '../base/dn-button-base/dn-button-base.component';
import { environment } from '../../environments/environment';

@Component({
  selector: 'dn-secondary-btn',
  templateUrl: './dn-secondary-btn.component.html',
  styleUrl: './dn-secondary-btn.component.scss',
  standalone: false,
})
export class DnSecondaryBtnComponent extends DnButtonBaseComponent {
  @Input() icon: string;

  get iconUrl(): string {
    return `${environment.icons_url}/${this.icon}`;
  }
}
